// extracted by mini-css-extract-plugin
module.exports = {"card":"BenefitCard_card__Ss5Kh","watermark":"BenefitCard_watermark__6WWCP","accentLine":"BenefitCard_accentLine__AKsY_","title":"BenefitCard_title__r9MTJ","description":"BenefitCard_description__Ykxdv"};
module.exports.__checksum = "37536c2e6836"
